export const EVENTS = {
  DisplaceSliderTo: 'displace-slider-to',
  WindowWidthChanged: 'window-width-changed'
};
